<template>
   <div>
        <div class="table-wrapper on-767" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="2" class="text-right text-white font-weight-bold">Collectively<br/>assessed</td>
                            <td class="text-right text-white font-weight-bold b-left">Individually<br/>assessed</td>
                            <td class="text-right text-white font-weight-bold b-left">Total</td>
                        </tr>
                        <tr class="med-gray">
                            <td colspan="2"><span class="invisible">asef</span></td>
                            <td class="text-center text-white font-weight-bold"> KD ’000</td>
                            <td ><span class="invisible">asef</span></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1 January 2019</td>
                            <td class="text-right">134,414</td>
                            <td class="text-right">10,525</td>
                            <td class="text-right">144,939</td>
                        </tr>
                        <tr>
                            <td>Recoveries</td>
                            <td class="text-right">362</td>
                            <td class="text-right">-</td>
                            <td class="text-right">362</td>
                        </tr>
                        <tr>
                            <td>Amounts written off</td>
                            <td class="text-right">(1,112)</td>
                            <td class="text-right">(648)</td>
                            <td class="text-right">(1,760)</td>
                        </tr>
                        <tr>
                            <td>Foreign exchange gains and losses</td>
                            <td class="text-right">(93)</td>
                            <td class="text-right">(281) </td>
                            <td class="text-right">(374)</td>
                        </tr>
                        <tr>
                            <td>Net increase in loss allowance</td>
                            <td class="text-right">25,091</td>
                            <td class="text-right">1,143 </td>
                            <td class="text-right">26,234</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="text-white font-weight-bold">31 December 2019 </td>
                            <td class="text-right text-white font-weight-bold">158,662</td>
                            <td class="text-right text-white font-weight-bold">10,739</td>
                            <td class="text-right text-white font-weight-bold">169,401</td>
                        </tr>
                        <tr>
                            <td>Recoveries</td>
                            <td class="text-right">331</td>
                            <td class="text-right">12 </td>
                            <td class="text-right">343</td>
                        </tr>
                        <tr>
                            <td>Amounts written off</td>
                            <td class="text-right">(3,211)</td>
                            <td class="text-right">(1,058)</td>
                            <td class="text-right">(4,269)</td>
                        </tr>
                        <tr>
                            <td>Foreign exchange gains and losses</td>
                            <td class="text-right">(1,926)</td>
                            <td class="text-right">(156)</td>
                            <td class="text-right">(2,082)</td>
                        </tr>
                        <tr>
                            <td>Net increase in loss allowance</td>
                            <td class="text-right">37,344</td>
                            <td class="text-right">9</td>
                            <td class="text-right">37,353</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="text-white font-weight-bold">31 December 2020 </td>
                            <td class="text-right text-white font-weight-bold">191,200</td>
                            <td class="text-right text-white font-weight-bold">9,546</td>
                            <td class="text-right text-white font-weight-bold">200,746</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!--Arabic-->

        <div class="table-wrapper on-767" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="2" class="text-right text-white font-weight-bold">تم تقييمها على<br/>أساس جماعي</td>
                            <td class="text-right text-white font-weight-bold b-left">تم تقييمها على<br/>أساس فردي</td>
                            <td class="text-right text-white font-weight-bold b-left">المجموع</td>
                        </tr>
                        <tr class="med-gray">
                            <td colspan="2"><span class="invisible">asef</span></td>
                            <td class="text-center text-white font-weight-bold">ألف دينار كويتي</td>
                            <td ><span class="invisible">asef</span></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1 يناير 2019</td>
                            <td class="text-right">134,414</td>
                            <td class="text-right">10,525</td>
                            <td class="text-right">144,939</td>
                        </tr>
                        <tr>
                            <td>استردادات</td>
                            <td class="text-right">362</td>
                            <td class="text-right">-</td>
                            <td class="text-right">362</td>
                        </tr>
                        <tr>
                            <td>مبالغ مشطوبة</td>
                            <td class="text-right">(1,112)</td>
                            <td class="text-right">(648)</td>
                            <td class="text-right">(1,760)</td>
                        </tr>
                        <tr>
                            <td>أرباح وخسائر صرف عملات أجنبية</td>
                            <td class="text-right">(93)</td>
                            <td class="text-right">(281) </td>
                            <td class="text-right">(374)</td>
                        </tr>
                        <tr>
                            <td>صافي الزيادة في مخصص الخسارة</td>
                            <td class="text-right">25,091</td>
                            <td class="text-right">1,143 </td>
                            <td class="text-right">26,234</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="text-white font-weight-bold">31 ديسمبر 2019</td>
                            <td class="text-right text-white font-weight-bold">158,662</td>
                            <td class="text-right text-white font-weight-bold">10,739</td>
                            <td class="text-right text-white font-weight-bold">169,401</td>
                        </tr>
                        <tr>
                            <td>استردادات</td>
                            <td class="text-right">331</td>
                            <td class="text-right">12 </td>
                            <td class="text-right">343</td>
                        </tr>
                        <tr>
                            <td>مبالغ مشطوبة</td>
                            <td class="text-right">(3,211)</td>
                            <td class="text-right">(1,058)</td>
                            <td class="text-right">(4,269)</td>
                        </tr>
                        <tr>
                            <td>أرباح وخسائر صرف عملات أجنبية</td>
                            <td class="text-right">(1,926)</td>
                            <td class="text-right">(156)</td>
                            <td class="text-right">(2,082)</td>
                        </tr>
                        <tr>
                            <td>صافي الزيادة في مخصص الخسارة</td>
                            <td class="text-right">37,344</td>
                            <td class="text-right">9</td>
                            <td class="text-right">37,353</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="text-white font-weight-bold">31 ديسمبر 2020</td>
                            <td class="text-right text-white font-weight-bold">191,200</td>
                            <td class="text-right text-white font-weight-bold">9,546</td>
                            <td class="text-right text-white font-weight-bold">200,746</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>